<div class="card card-box">
  <div class="card-header">
    <div class="display-5  card-header--title font-weight-bold" style="font-size: 16px;">
      Customer Paid Transactions
    </div>
    <div class="card-header--actions">
      <!-- <button id="backBtn" *ngIf="!isActive('home/ar-dashboard')" class="btn btn btn-sm btn-primary btn-square" type="button" (click)="onBackToDashboard()">Back</button> &nbsp; -->
      <button (click)="getPaidTransactions()" tooltip="Refresh" id="reloadInprogress"
        class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2" type="button">
        <span class="btn-wrapper--icon">
          <i class="ion-md-sync"></i>
        </span>
      </button>
      <!--<div class="btn-group btn-group-sm" dropdown placement="bottom right">
                <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" (click)="showFilter()"
                    dropdownToggle type="button">
                    <span class="btn-wrapper--label">Filters</span>
                    <span class="btn-wrapper--icon">
                        <fa-icon *ngIf="!isShow" [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1">
                        </fa-icon>
                        <fa-icon *ngIf="isShow" [icon]="['fas', 'chevron-up']" class="opacity-8 font-size-xs ml-1">
                        </fa-icon>
                    </span>
                </button>
            </div>
            <button (click)="exportExcel()" tooltip="Excel" id="excelBtn"
                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                type="button">
                <fa-icon [icon]="['far', 'file-excel']" class="h5 d-block mb-2 mt-1 text-primary btn-wrapper--icon">
                </fa-icon>
            </button>
            <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                <button tooltip="Refresh" (click)="onReset()"
                    class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                    type="button">
                    <span class="btn-wrapper--icon">
                        <i class="ion-md-sync"></i>
                    </span>
                </button>
            </div>-->
    </div>
  </div>

  <div class="card-body">
    <div>
      <div class=" justify-content-between">
        <div *ngIf="isShow">
          <form [formGroup]="filters_form" novalidate>
            <!-- <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label> Reservation Type</label>
                                    <ng-select formControlName="resType" [multiple]="true">
                                        <ng-option value="AMEX">AMEX </ng-option>
                                        <ng-option value="Retail">Retail </ng-option>
                                        <ng-option value="Retail-Web">Retail-Web </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Reservation From Date</label>
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                </fa-icon>
                                            </span>
                                        </div>
                                        <input [bsConfig]="{
                                containerClass: 'theme-primary',
                                isAnimated: true,
                                customTodayClass: 'custom-today-class'
                              }" bsDatepicker formControlName="startdate" class="form-control"
                                            placeholder="Select date" type="text" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Reservation To Date</label>
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                </fa-icon>
                                            </span>
                                        </div>
                                        <input [bsConfig]="{
                                containerClass: 'theme-primary',
                                isAnimated: true,
                                customTodayClass: 'custom-today-class'
                              }" bsDatepicker formControlName="enddate" class="form-control" placeholder="Select date"
                                            type="text" />
                                    </div>
                                </div>
                            </div>
                        </div> -->
            <!-- <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label> Stations</label>
                                    <ng-select [multiple]="true" formControlName="stationcodes">
                                        <div *ngFor="let station of stations">
                                            <ng-option [value]="station.stationid">
                                                {{station?.airportName}}</ng-option>
                                        </div>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group pt-4">
                                    <button class="btn  mt-2 btn-sm btn-block btn-primary btn-square" type="button"
                                        (click)="onFilter(filters_form.value)">
                                        Search
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group pt-4">
                                    <button class="btn btn-sm mt-2  btn-block btn-primary btn-square" type="button"
                                        (click)="onReset()">
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div> -->
          </form>
        </div>
        <div class="d-flex justify-content-between pb-3">
          <div class="search-wrapper">
            <span class="icon-wrapper text-black">
              <fa-icon [icon]="['fas', 'search']"></fa-icon>
            </span>
            <input type="text" class="form-control form-control-sm rounded-pill" placeholder="ResID, Station"
              [ngModelOptions]="{ standalone: true }" [(ngModel)]="searchText" />
          </div>
        </div>
        <div *ngIf="arPaidTrans | tsearch: searchText; let filtereddayBeforeData">
          <div class="table-responsive table-scroll">
            <table id="report25con" class="table table-hover table-striped table-bordered text-nowrap mb-3"
              [mfData]="filtereddayBeforeData" #mf="mfDataTable" [mfRowsOnPage]="100">
              <thead class="thead-light">
                <tr>

                  <th class="bg-white text-left">
                    Res ID
                  </th>
                  <th class="bg-white text-left">
                    Res Type
                  </th>

                  <th class="bg-white text-left">
                    Res Status
                  </th>
                  <th class="bg-white text-left">
                    Billing Status
                  </th>

                  <th class="bg-white text-left">
                    Currency
                  </th>
                  <th class="bg-white text-left">
                    Station
                  </th>
                  <!-- <th class="bg-white text-left">
                                        Reservation Creation Date
                                      </th> -->

                  <th class="bg-white text-left">
                    Reservation Start Date
                  </th>
                  <th class="bg-white text-left">
                    Invoice ID
                  </th>
                  <th class="bg-white text-left">
                    Sub Total
                  </th>

                  <th class="bg-white text-left">
                    Taxes
                  </th>


                  <th class="bg-white text-left">
                    Total
                  </th>
                  <th class="bg-white text-left">
                    Transaction Type
                  </th>

                  <th class="bg-white text-left">
                    Transaction REF ID
                  </th>
                  <th class="bg-white text-left">
                    Customer Name
                  </th>
                  <th class="bg-white text-left">
                    Customer Bill To (Company Name)
                  </th>
                  <th class="bg-white text-left">
                    Payment Closed Date
                  </th>
                  <th class="bg-white text-left">
                    Notes
                  </th>
                  <th>
                    Print Invoice
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let trans of mf.data let i=index;">
                  <td class="font-weight-bold">

                    <span> {{trans.RESID}} </span> &nbsp;&nbsp;
                    <!-- *ngIf="trans.RESSTATUS == 'Completed'" -->
                    <button [routerLink]="['/home/bookings/greet-progress', trans.RESID, 2]"
                      class="btn btn-sm btn-pill btn-neutral-primary" style="padding: 0px 10px;"
                      tooltip="Greet Status Management" type="button">
                      <span class="btn-wrapper--icon font-size-lg">
                        <i class="ion-md-information-circle"></i>
                      </span>
                    </button>

                  </td>

                  <td class="text-left">
                    {{trans.RES_TYPE}}
                  </td>

                  <td class="text-left">
                    {{trans.RESSTATUS}}
                  </td>
                  <td class="text-left">
                    <span *ngIf="trans.GREET_SERVICE_BACKOFFICE_STATUS"> {{ trans.GREET_SERVICE_BACKOFFICE_STATUS
                      }}</span>
                  </td>

                  <td class="text-left">
                    {{trans.CURRENCY_FLAG}}
                  </td>
                  <td class="text-left">
                    {{trans.STATION}}
                  </td>

                  <!-- <td class="text-left">
                                        {{trans.RESCREATIONDT | date : 'mediumDate'}}
                                    </td> -->
                  <td class="text-left">
                    {{trans.STARTDT | date : 'mediumDate'}}
                  </td>

                  <td class="text-left">
                    {{trans.INVOICE_RECEIPT_ID}}
                  </td>
                  <td class="text-left">
                    {{trans.TRANSACTION_SUBTOTAL}}
                  </td>
                  <td class="text-left">
                    {{trans.TRANSACTION_TAXES}}
                  </td>

                  <td class="text-left">
                    {{trans.TRANSACTION_TOTAL}}
                  </td>
                  <td class="text-left">
                    {{trans.TRANSACTION_TYPE}}
                  </td>
                  <td class="text-left">
                    <span *ngIf="trans.TRANSACTION_TYPE === 'Credit Card' "> {{trans.CCTRANSACTION_NUMBER}} </span>
                    <span *ngIf="trans.CHEQUE_NUMBER">,&nbsp; {{trans.CHEQUE_NUMBER}} </span>
                  </td>
                  <td class="text-left">
                    {{trans.CONTACT_NAME}}
                  </td>
                  <td class="text-left">
                    {{trans.COMPANY_NAME}}
                  </td>
                  <td class="text-left">
                    {{trans.PAYMENT_CLOSED_DATE | date : 'mediumDate'}}
                  </td>
                  <td class="text-left">
                    {{trans.NOTES}}
                  </td>
                  <td>
                    <span *ngIf="trans.PRINTED == 1">
                      <button [routerLink]="['/home/ar-customer-invoice', trans.RESID,1]"
                        class="btn btn-sm btn-neutral-success" tooltip="Print Invoice" type="button">
                        Invoice
                      </button></span>
                    <span *ngIf="trans.PRINTED == 0">
                      <button [routerLink]="['/home/ar-customer-invoice', trans.RESID,1]"
                        class="btn btn-sm btn-neutral-primary" tooltip="Print Invoice" type="button">
                        Invoice
                      </button> </span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="25">
                    <span class="font-weight-bold">Total Records: {{
                      filtereddayBeforeData.length
                      }}</span> &nbsp;&nbsp;&nbsp;
                    <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                    </mfBootstrapPaginator>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>